export default __webpack_public_path__ + "static/media/hero16-with-crown.3c4ded65.png";